require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e["default"];
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 0);
}([function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      o = n(1),
      i = c(o),
      u = c(n(4));

  function c(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  var a = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return n.addMainScript = n.addMainScript.bind(n), n.addIdentityVariables = n.addIdentityVariables.bind(n), n.insertScript = n.insertScript.bind(n), n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, i["default"].Component), r(t, [{
      key: "insertScript",
      value: function value(e) {
        var t = document.createElement("script");
        t.innerText = e, t.async = !0, document.body.appendChild(t);
      }
    }, {
      key: "addMainScript",
      value: function value() {
        var e = '!function() {\n        var t = window.driftt = window.drift = window.driftt || [];\n        if (!t.init) {\n          if (t.invoked) return void (window.console && console.error && console.error("Drift snippet included twice."));\n          t.invoked = !0, t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on", "setUserAttributes" ], \n          t.factory = function(e) {\n            return function() {\n              var n = Array.prototype.slice.call(arguments);\n              return n.unshift(e), t.push(n), t;\n            };\n          }, t.methods.forEach(function(e) {\n            t[e] = t.factory(e);\n          }), t.load = function(t) {\n            var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");\n            o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js";\n            var i = document.getElementsByTagName("script")[0];\n            i.parentNode.insertBefore(o, i);\n          };\n        }\n      }();\n      drift.SNIPPET_VERSION = \'0.3.1\';\n      drift.load(\'' + this.props.appId + "');";
        this.insertScript(e);
      }
    }, {
      key: "addIdentityVariables",
      value: function value() {
        if (void 0 !== this.props.userId) {
          var e = "\n        var t = window.driftt = window.drift = window.driftt || [];\n        drift.identify('" + this.props.userId + "', " + JSON.stringify(this.props.attributes) + ")\n      ";
          this.insertScript(e);
        }
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        "undefined" == typeof window || window.drift || (this.addMainScript(), this.addIdentityVariables());
      }
    }, {
      key: "render",
      value: function value() {
        return i["default"].createElement(o.Fragment, null);
      }
    }]), t;
  }(),
      f = {
    appId: u["default"].string.isRequired,
    attributes: u["default"].object
  };

  a.propTypes = f, t["default"] = a;
}, function (e, t, n) {
  "use strict";

  e.exports = n(2);
}, function (e, t, n) {
  "use strict";
  /** @license React v16.8.6
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var r = n(3),
      o = "function" == typeof Symbol && Symbol["for"],
      i = o ? Symbol["for"]("react.element") : 60103,
      u = o ? Symbol["for"]("react.portal") : 60106,
      c = o ? Symbol["for"]("react.fragment") : 60107,
      a = o ? Symbol["for"]("react.strict_mode") : 60108,
      f = o ? Symbol["for"]("react.profiler") : 60114,
      l = o ? Symbol["for"]("react.provider") : 60109,
      s = o ? Symbol["for"]("react.context") : 60110,
      p = o ? Symbol["for"]("react.concurrent_mode") : 60111,
      d = o ? Symbol["for"]("react.forward_ref") : 60112,
      y = o ? Symbol["for"]("react.suspense") : 60113,
      b = o ? Symbol["for"]("react.memo") : 60115,
      v = o ? Symbol["for"]("react.lazy") : 60116,
      m = "function" == typeof Symbol && Symbol.iterator;

  function h(e) {
    for (var t = arguments.length - 1, n = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, r = 0; r < t; r++) {
      n += "&args[]=" + encodeURIComponent(arguments[r + 1]);
    }

    !function (e, t, n, r, o, i, u, c) {
      if (!e) {
        if (e = void 0, void 0 === t) e = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var a = [n, r, o, i, u, c],
              f = 0;
          (e = Error(t.replace(/%s/g, function () {
            return a[f++];
          }))).name = "Invariant Violation";
        }
        throw e.framesToPop = 1, e;
      }
    }(!1, "Minified React error #" + e + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", n);
  }

  var _ = {
    isMounted: function isMounted() {
      return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
  },
      g = {};

  function w(e, t, n) {
    this.props = e, this.context = t, this.refs = g, this.updater = n || _;
  }

  function S() {}

  function O(e, t, n) {
    this.props = e, this.context = t, this.refs = g, this.updater = n || _;
  }

  w.prototype.isReactComponent = {}, w.prototype.setState = function (e, t) {
    "object" != typeof e && "function" != typeof e && null != e && h("85"), this.updater.enqueueSetState(this, e, t, "setState");
  }, w.prototype.forceUpdate = function (e) {
    this.updater.enqueueForceUpdate(this, e, "forceUpdate");
  }, S.prototype = w.prototype;
  var j = O.prototype = new S();
  j.constructor = O, r(j, w.prototype), j.isPureReactComponent = !0;
  var k = {
    current: null
  },
      P = {
    current: null
  },
      x = Object.prototype.hasOwnProperty,
      E = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function C(e, t, n) {
    var r = void 0,
        o = {},
        u = null,
        c = null;
    if (null != t) for (r in void 0 !== t.ref && (c = t.ref), void 0 !== t.key && (u = "" + t.key), t) {
      x.call(t, r) && !E.hasOwnProperty(r) && (o[r] = t[r]);
    }
    var a = arguments.length - 2;
    if (1 === a) o.children = n;else if (1 < a) {
      for (var f = Array(a), l = 0; l < a; l++) {
        f[l] = arguments[l + 2];
      }

      o.children = f;
    }
    if (e && e.defaultProps) for (r in a = e.defaultProps) {
      void 0 === o[r] && (o[r] = a[r]);
    }
    return {
      $$typeof: i,
      type: e,
      key: u,
      ref: c,
      props: o,
      _owner: P.current
    };
  }

  function R(e) {
    return "object" == typeof e && null !== e && e.$$typeof === i;
  }

  var T = /\/+/g,
      $ = [];

  function I(e, t, n, r) {
    if ($.length) {
      var o = $.pop();
      return o.result = e, o.keyPrefix = t, o.func = n, o.context = r, o.count = 0, o;
    }

    return {
      result: e,
      keyPrefix: t,
      func: n,
      context: r,
      count: 0
    };
  }

  function M(e) {
    e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > $.length && $.push(e);
  }

  function A(e, t, n) {
    return null == e ? 0 : function e(t, n, r, o) {
      var c = typeof t;
      "undefined" !== c && "boolean" !== c || (t = null);
      var a = !1;
      if (null === t) a = !0;else switch (c) {
        case "string":
        case "number":
          a = !0;
          break;

        case "object":
          switch (t.$$typeof) {
            case i:
            case u:
              a = !0;
          }

      }
      if (a) return r(o, t, "" === n ? "." + N(t, 0) : n), 1;
      if (a = 0, n = "" === n ? "." : n + ":", Array.isArray(t)) for (var f = 0; f < t.length; f++) {
        var l = n + N(c = t[f], f);
        a += e(c, l, r, o);
      } else if (l = null === t || "object" != typeof t ? null : "function" == typeof (l = m && t[m] || t["@@iterator"]) ? l : null, "function" == typeof l) for (t = l.call(t), f = 0; !(c = t.next()).done;) {
        a += e(c = c.value, l = n + N(c, f++), r, o);
      } else "object" === c && h("31", "[object Object]" == (r = "" + t) ? "object with keys {" + Object.keys(t).join(", ") + "}" : r, "");
      return a;
    }(e, "", t, n);
  }

  function N(e, t) {
    return "object" == typeof e && null !== e && null != e.key ? function (e) {
      var t = {
        "=": "=0",
        ":": "=2"
      };
      return "$" + ("" + e).replace(/[=:]/g, function (e) {
        return t[e];
      });
    }(e.key) : t.toString(36);
  }

  function V(e, t) {
    e.func.call(e.context, t, e.count++);
  }

  function U(e, t, n) {
    var r = e.result,
        o = e.keyPrefix;
    e = e.func.call(e.context, t, e.count++), Array.isArray(e) ? q(e, r, n, function (e) {
      return e;
    }) : null != e && (R(e) && (e = function (e, t) {
      return {
        $$typeof: i,
        type: e.type,
        key: t,
        ref: e.ref,
        props: e.props,
        _owner: e._owner
      };
    }(e, o + (!e.key || t && t.key === e.key ? "" : ("" + e.key).replace(T, "$&/") + "/") + n)), r.push(e));
  }

  function q(e, t, n, r, o) {
    var i = "";
    null != n && (i = ("" + n).replace(T, "$&/") + "/"), A(e, U, t = I(t, i, r, o)), M(t);
  }

  function D() {
    var e = k.current;
    return null === e && h("321"), e;
  }

  var F = {
    Children: {
      map: function map(e, t, n) {
        if (null == e) return e;
        var r = [];
        return q(e, r, null, t, n), r;
      },
      forEach: function forEach(e, t, n) {
        if (null == e) return e;
        A(e, V, t = I(null, null, t, n)), M(t);
      },
      count: function count(e) {
        return A(e, function () {
          return null;
        }, null);
      },
      toArray: function toArray(e) {
        var t = [];
        return q(e, t, null, function (e) {
          return e;
        }), t;
      },
      only: function only(e) {
        return R(e) || h("143"), e;
      }
    },
    createRef: function createRef() {
      return {
        current: null
      };
    },
    Component: w,
    PureComponent: O,
    createContext: function createContext(e, t) {
      return void 0 === t && (t = null), (e = {
        $$typeof: s,
        _calculateChangedBits: t,
        _currentValue: e,
        _currentValue2: e,
        _threadCount: 0,
        Provider: null,
        Consumer: null
      }).Provider = {
        $$typeof: l,
        _context: e
      }, e.Consumer = e;
    },
    forwardRef: function forwardRef(e) {
      return {
        $$typeof: d,
        render: e
      };
    },
    lazy: function lazy(e) {
      return {
        $$typeof: v,
        _ctor: e,
        _status: -1,
        _result: null
      };
    },
    memo: function memo(e, t) {
      return {
        $$typeof: b,
        type: e,
        compare: void 0 === t ? null : t
      };
    },
    useCallback: function useCallback(e, t) {
      return D().useCallback(e, t);
    },
    useContext: function useContext(e, t) {
      return D().useContext(e, t);
    },
    useEffect: function useEffect(e, t) {
      return D().useEffect(e, t);
    },
    useImperativeHandle: function useImperativeHandle(e, t, n) {
      return D().useImperativeHandle(e, t, n);
    },
    useDebugValue: function useDebugValue() {},
    useLayoutEffect: function useLayoutEffect(e, t) {
      return D().useLayoutEffect(e, t);
    },
    useMemo: function useMemo(e, t) {
      return D().useMemo(e, t);
    },
    useReducer: function useReducer(e, t, n) {
      return D().useReducer(e, t, n);
    },
    useRef: function useRef(e) {
      return D().useRef(e);
    },
    useState: function useState(e) {
      return D().useState(e);
    },
    Fragment: c,
    StrictMode: a,
    Suspense: y,
    createElement: C,
    cloneElement: function cloneElement(e, t, n) {
      null == e && h("267", e);
      var o = void 0,
          u = r({}, e.props),
          c = e.key,
          a = e.ref,
          f = e._owner;

      if (null != t) {
        void 0 !== t.ref && (a = t.ref, f = P.current), void 0 !== t.key && (c = "" + t.key);
        var l = void 0;

        for (o in e.type && e.type.defaultProps && (l = e.type.defaultProps), t) {
          x.call(t, o) && !E.hasOwnProperty(o) && (u[o] = void 0 === t[o] && void 0 !== l ? l[o] : t[o]);
        }
      }

      if (1 === (o = arguments.length - 2)) u.children = n;else if (1 < o) {
        l = Array(o);

        for (var s = 0; s < o; s++) {
          l[s] = arguments[s + 2];
        }

        u.children = l;
      }
      return {
        $$typeof: i,
        type: e.type,
        key: c,
        ref: a,
        props: u,
        _owner: f
      };
    },
    createFactory: function createFactory(e) {
      var t = C.bind(null, e);
      return t.type = e, t;
    },
    isValidElement: R,
    version: "16.8.6",
    unstable_ConcurrentMode: p,
    unstable_Profiler: f,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
      ReactCurrentDispatcher: k,
      ReactCurrentOwner: P,
      assign: r
    }
  },
      L = {
    "default": F
  },
      B = L && F || L;
  e.exports = B["default"] || B;
}, function (e, t, n) {
  "use strict";
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  var r = Object.getOwnPropertySymbols,
      o = Object.prototype.hasOwnProperty,
      i = Object.prototype.propertyIsEnumerable;

  function u(e) {
    if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e);
  }

  e.exports = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

      for (var t = {}, n = 0; n < 10; n++) {
        t["_" + String.fromCharCode(n)] = n;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, t) {
    for (var n, c, a = u(e), f = 1; f < arguments.length; f++) {
      for (var l in n = Object(arguments[f])) {
        o.call(n, l) && (a[l] = n[l]);
      }

      if (r) {
        c = r(n);

        for (var s = 0; s < c.length; s++) {
          i.call(n, c[s]) && (a[c[s]] = n[c[s]]);
        }
      }
    }

    return a;
  };
}, function (e, t, n) {
  e.exports = n(5)();
}, function (e, t, n) {
  "use strict";

  var r = n(6);

  function o() {}

  function i() {}

  i.resetWarningCache = o, e.exports = function () {
    function e(e, t, n, o, i, u) {
      if (u !== r) {
        var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw c.name = "Invariant Violation", c;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: i,
      resetWarningCache: o
    };
    return n.PropTypes = n, n;
  };
}, function (e, t, n) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}]);